import { URLConfiguration } from "./../constants/url.configuration";
import { HeadersMapping } from "./../mappings/headers.mapping";
import ApiProvider from "./../../../lib/providers/ApiProvider";
import { serviceUtil } from "./../utils/services";

class TokenProvider {
    
    constructor() {
        this.paths          = URLConfiguration.paths;
        this.apiProvider = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH)
    }

    getToken = async () => {

        const headers = HeadersMapping.getHeaderToken();

        const bodyToken = {
            resource: process.env.REACT_APP_RESOURCE_TOKEN
        }
        
        let infoToken = serviceUtil.getDataToken();
        
        if (!infoToken) {
            const dataToken = await this.apiProvider.post(this.paths.token, bodyToken, { headers });
            serviceUtil.saveDataToken(dataToken.data);
            infoToken = dataToken;
        }

        return infoToken;
    }
}

export default TokenProvider;